import { Card, Icon } from "@helmr/ui";
import { Link } from "react-router-dom";
import { css as s, PageHead, useScope } from "../payroll/kit";
import { REPORT_DEFS, reportLever } from "./defs";
import r from "./reports.module.css";

/** `/reports`: one card per report. Money reports are hidden without `see_revenue`; the server refuses them anyway. */
export function ReportsPage() {
  const sc = useScope();
  const visible = REPORT_DEFS.filter((d) => sc.ctx.has(reportLever(d.name)));
  return (
    <div className={s.page}>
      <PageHead title="Reports" sub="Numbers straight from your records, with a CSV for each." />
      <div className={r.grid}>
        {visible.map((d) => (
          <Card key={d.name} as="article" className={r.tile}>
            <Link to={`/reports/${d.name}`}><span className={r.ico}><Icon name={d.icon} /></span><b>{d.title}</b><small>{d.blurb}</small></Link>
          </Card>
        ))}
      </div>
    </div>
  );
}
